import axios from 'axios';

class Newsletter {
    constructor() {
        this.news = document.querySelectorAll('.js-newsletter-form');
        if (this.news.length) {
            this.news.forEach((news) => {
                Newsletter.bindNewsletter(news);
            });
        }
    }

    static bindNewsletter(news) {
        const form = news.querySelector('form');
        const message = news.querySelector('.message');

        form.addEventListener('submit', (e) => {
            const email = form.querySelector('[name="email"]').value;
            const firstName = form.querySelector('[name="first_name"]').value;
            const lastName = form.querySelector('[name="last_name"]').value;
            const target = form.action;
            axios.post(target, { email, first_name: firstName, last_name: lastName });
            news.querySelector('.input-block').classList.add('hidden');
            message.classList.add('visible');
            e.preventDefault();
            return false;
        });
    }
}

export default Newsletter;
